<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  components: {
    RawData,
  },
  data() {
    return {
      submitted: false,
      modalTitle: "",
      tableData: [],
      itemData: null,
      filter: "",
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      currentPage: 1,
      perPageItem: 10,
      currentPageForm: 1,
      loading: false,
      form: {
        type: "",
        isRequest: true,
      },
    };
  },
  validations: {
    form: {
      type: { required },
    },
  },
  computed: {
    filtered() {
      let data = this.tableData;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          if (item.type) {
            if (item.type.toUpperCase().includes(this.filter.toUpperCase()))
              return item.type
                .toUpperCase()
                .includes(this.filter.toUpperCase());
          }
        });
      }
      return data.sort(function (a, b) {
        if (a.type < b.type) {
          return -1;
        }
        if (a.type > b.type) {
          return 1;
        }
        return 0;
      });
    },
    paginated() {
      let data = this.filtered;
      var total = this.currentPage * this.perPage;
      var currentData = data.slice(total - this.perPage, total);
      if (this.currentPage > 1 && currentData.length == 0) {
        total = (this.currentPage - 1) * this.perPage;
        currentData = data.slice(total - this.perPage, total);
      }
      return currentData;
    },
    rows() {
      return this.filtered.length;
    },
  },
  // created() {
  //   this.getData();
  // },
  methods: {
    getData() {
      this.loading = true;
      this.$store
        .dispatch("dtsactiontype/GetActionType")
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          this.tableData = res.data.reverse();
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting available items!",
              "error"
            );
          }
        });
      this.loading = false;
    },
    onSubmit() {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      if (this.form.id) {
        this.$store
          .dispatch("dtsactiontype/UpdateActionType", this.form)
          .then((res) => {
            var index = this.tableData.findIndex(
              (item) => item.id == this.form.id
            );
            this.tableData.splice(index, 1, this.form);
            this.$bvModal.hide("modal-actionType");
            this.showToast("Successfully updated!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      } else {
        this.$store
          .dispatch("dtsactiontype/CreateActionType", this.form)
          .then((res) => {
            this.tableData.push(res.data);
            this.$bvModal.hide("modal-actionType");
            this.showToast("Successfully created!", "success");
          })
          .catch((err) => {
            this.showToast("Something went wrong!", "error");
          });
      }
    },
    addActionType() {
      this.onReset();
      this.modalTitle = "Create Action Type";
      this.$bvModal.show("modal-actionType");
    },
    updateActionType(props) {
      this.form = cloneDeep(props);
      this.modalTitle = "Update Action Type";
      this.$bvModal.show("modal-actionType");
    },
    deleteActionType(props) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtsactiontype/DeleteActionType", props.id)
            .then((res) => {
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onReset() {
      this.submitted = false;
      this.form = {
        type: "",
        isRequest: true,
      };
    },
  },
};
</script>
<template>
  <div class="ps-2 py-2" style="min-width: 950px">
    <b-modal
      id="modal-actionType"
      :title="modalTitle"
      size="md"
      title-class="font-18"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <form
        @submit.prevent="onSubmit"
        class="needs-validation"
        ref="targetForm"
      >
        <div class="mb-3">
          <label for="type">Action </label>
          <input
            id="type"
            type="text"
            v-model="form.type"
            placeholder="Enter Action..."
            class="form-control"
            :class="{
              'is-invalid': submitted && $v.form.type.$error,
            }"
            autocomplete="off"
          />
          <div v-if="submitted && $v.form.type.$error" class="invalid-feedback">
            <span v-if="!$v.form.type.required">This value is required.</span>
          </div>
        </div>
        <div class="d-flex float-end">
          <button type="submit" class="btn btn-primary">Submit</button>
        </div>
      </form>
    </b-modal>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h5 class="mb-0">List of Action Types</h5>
      <button
        type="button"
        @click="addActionType()"
        class="btn btn-sm btn-success d-flex align-items-center ms-1"
      >
        <i class="bx bx-plus fs-6 me-1"></i>Create Action Type
      </button>
    </div>
    <div class="d-flex flex-row-reverse mb-3">
      <div class="d-flex align-items-center">
        <div id="tickets-table_filter" class="dataTables_filter me-1">
          <label class="d-inline-flex align-items-center mb-0">
            <b-form-input
              autocomplete="off"
              v-model="filter"
              type="search"
              placeholder="Search Action Type..."
              class="form-control"
            ></b-form-input>
          </label>
        </div>
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center mb-0">
            <b-form-select
              class="form-select"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            >
            </b-form-select>
          </label>
        </div>
      </div>
    </div>
    <b-card v-if="loading">
      <div class="d-flex align-items-center justify-content-center">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-25px h-25px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <h5 class="mb-0">Loading...</h5>
      </div>
    </b-card>
    <b-card class="text-center" v-else-if="paginated.length == 0">
      <div v-if="filter != ''">
        <i class="fas fa-exclamation-triangle me-2"></i>There are no items
        matching your request
      </div>
      <div v-else>
        <i class="fas fa-exclamation-triangle me-2"></i>No items available
      </div>
    </b-card>
    <div v-else class="text-muted">
      <b-card no-body class="m-0 mb-3">
        <b-card-header>
          <div class="row align-items-center">
            <div class="col-11">
              <b>Name</b>
            </div>
            <div class="col-1 text-end">
              <b>Actions</b>
            </div>
          </div>
        </b-card-header>
      </b-card>
      <div role="tablist" v-for="(x, index) in paginated" :key="x.id">
        <div class="position-relative ms-1">
          <RawData
            :data="x"
            v-if="$store.state.decrypt.isAdmin()"
            :style="`z-index: ${paginated.length - index + 11}`"
          />
        </div>
        <b-card
          no-body
          class="m-0 mb-3 py-1"
          :style="`z-index: ${paginated.length - index + 10}`"
        >
          <b-card-header>
            <div class="row align-items-center">
              <div class="col-11">
                <div>
                  {{ x.type }}
                </div>
              </div>
              <div class="col-1">
                <div class="d-flex justify-content-end">
                  <i
                    class="fas fa-ellipsis-v cursor-pointer ps-2 pe-2 ms-2"
                    :id="`action-popover-${x.id}`"
                    tabindex="0"
                  ></i>
                  <b-popover
                    :target="`action-popover-${x.id}`"
                    triggers="click blur"
                    placement="leftbottom"
                    variant="secondary"
                    custom-class="p-0"
                  >
                    <b-list-group class="w-100 fit">
                      <b-list-group-item
                        button
                        action
                        class="d-flex align-items-center text-info"
                        @click="updateActionType(x)"
                        ><i class="bx bx-edit font-size-18 me-1"></i>Update
                        Action Type</b-list-group-item
                      >
                      <b-list-group-item
                        button
                        action
                        class="d-flex align-items-center text-danger"
                        @click="deleteActionType(x)"
                        ><i class="bx bx-trash font-size-18 me-1"></i>Delete
                        Action Type</b-list-group-item
                      >
                    </b-list-group>
                  </b-popover>
                </div>
              </div>
            </div>
          </b-card-header>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div v-if="rows > 0" class="col">
        Showing {{ (currentPage - 1) * perPage + 1 }} -
        {{
          rows > (currentPage - 1) * perPage + perPage
            ? (currentPage - 1) * perPage + perPage
            : rows
        }}
        of {{ rows }}
      </div>
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>